import { useContext } from 'react';

import { CompanyAuthContext } from './CompanyAuthContext';

export const useCompanyAuth = () => {
  const context = useContext(CompanyAuthContext);
  if (context === undefined) {
    throw new Error('useCompanyAuth must be used within a CompanyAuthProvider');
  }
  return context;
};
